import { BrowserRouter } from 'react-router-dom';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Provider as ChatProvider } from '@dpdgroupuk/cc-chat-fe';
import '@dpdgroupuk/cc-chat-fe/dist/components/ChatBotApp.css';
import TagManager from 'react-gtm-module';
import { useEffect } from 'react';
import Footer from './components/Footer/Footer';
import AppRoutes from './router/Routes';
import AppBar from './components/AppBar';
import AuthProvider from './features/Auth/AuthProvider';
import { OverlayProvider } from './features/Overlay';
import { CustomSnackbarProvider } from './features/CustomSnackbar';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import DataProvider from './DataProvider';
import { CHAT_CONFIG } from './constants/env';

const StyledBox = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const StyledContainer = styled(Box)({
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
});

export default function App() {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: import.meta.env.VITE_GTM_ID,
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <BrowserRouter>
      <OverlayProvider>
        <StyledBox>
          <CustomSnackbarProvider>
            <StyledContainer>
              <ChatProvider chatConfig={CHAT_CONFIG}>
                <AuthProvider>
                  <DataProvider>
                    <ScrollToTop />
                    <AppBar />
                    <AppRoutes />
                  </DataProvider>
                </AuthProvider>
              </ChatProvider>
            </StyledContainer>
            <Footer />
          </CustomSnackbarProvider>
        </StyledBox>
      </OverlayProvider>
    </BrowserRouter>
  );
}
